import React from 'react';
import Page from 'structure/page';
import { withPrices } from 'service';

export const UnwrappedFaq = ({ prices, ...props }) => (
  <Page title='Frequently Asked Questions' {...props}>
    <h3>What Are Corsets Made From?</h3>
    <p>
      Creative Corsetry's corsets are made from coutil (this is a special corsetry fabric which is very strong and has very little
      stretch so that your corset will conform to your body perfectly. In some cases one of the layers of coutil is also the
      decorative layer.) Unless the coutil is decorative or the corset is purely functional we use another layer of fabric called
      the fashion fabric which is the outer decorative fabric. We can also add a decorative lining on request. We use spiral and
      spring steel boning.
    </p>
    <h3>How Long Does It Take? Do You Have Stock?</h3>
    <p>
      Each corset is made to order so we don't have any in stock.
      Usually it takes up to four weeks before your corset will be posted to you.
    </p>
    <h3>What Are Your Shipping Prices?</h3>
    <p>Shipping within Australia is $A{prices.domesticShipping} and international shipping is $A{prices.internationalShipping}</p>
    <h3>Putting On Your Corset</h3>
    <p>
      Make sure the laces on the back are loose enough that the corset will fit around your body comfortably and that it is the
      right way up. (If the busk has two studs closer together than the others they will be at the bottom of the corset.
        Otherwise, if you look at the back of the corset where the laces are you will notice that the laces are knotted at one end.
        This is the bottom of the corset.) Now do up the busk. It is easiest to start at the bottom and work your way up.
        Sometimes this is a little awkward but it will get easier with practice! Now you just need to tighten your laces.
        Start at the top or the bottom. It doesn't matter which. Just pull the laces like you would your shoe laces until you reach
        the middle. Pull the long lace. Then go to the other end and do the same thing. Tie the long laces in the middle with a knot
        and a bow. Don't tie them around your waist as this can damage your corset.
        Warning. It is important that you are not rough and do not jerk the laces when tightening them and don't just pull the long
        laces, thinking that it will be quicker or easier because if you do you may hurt yourself or you may damage the grommets.
      </p>
      <h3>Taking Off Your Corset.</h3>
      <p>
        When you take off your corset first loosen the laces at the back then undo the busk.
        Never undo the busk without loosening the laces first as the sudden lack of pressure may cause yourself or your corset harm.
      </p>
      <h3>Corset Cleaning</h3>
      <p>We recommend that you have your corset dry cleaned by a reputable dry cleaner.</p>
      <h3>Storing Your Corset</h3>
      <p>After wearing your corset it is a good idea to let it air out before putting it away. Hanging it over the back of a chair
        for a day or two is a good way. Don't roll up your corset to put it away. Let it lie flat. You can also hang it in a bag.
      </p>
    </Page>
);

export default withPrices(UnwrappedFaq);



// WEBPACK FOOTER //
// ./src/pages/faq/faq.js